export enum Action {
  View_Order = 'View Order',
  Cancel_Request = 'Cancel Request',
  Delete_Request = 'delete'
}

export enum RequestStatusType {
  Submitted = 'SUBMITTED',
  Rejected = 'REJECTED',
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Error = 'ERROR',
  Editing = 'EDITING',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
}
